import __request__ from "routing/request";
export function add(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.watchlist/watchlist/add", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function checkValues(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.watchlist/watchlist/checkFieldValues", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.watchlist/watchlist/remove", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
